import React from "react";

/**  Lazy loading components for improved performance
*   React.lazy is used to dynamically import components when they are needed
*/

export const AdminLogin = React.lazy(() => import("./Login/index.page"));
export const AdminForgotPassword = React.lazy(() =>
  import("./ForgotPassword/index.page")
);
export const AdminOtpVerification = React.lazy(() =>
  import("./OtpVerification/index.page")
);
export const AdminResetPassword = React.lazy(() =>
  import("./ResetPassword/index.page")
);
export const AdminProfile = React.lazy(() =>
  import("./AdminAccount/AdminProfile/index.page")
);
export const AdminChangePassword = React.lazy(() =>
  import("./AdminAccount/AdminChangePassword/index.page")
);
export const AdminNotifications = React.lazy(() =>
  import("./AdminAccount/AdminNotifications/index.page")
);
export const AdminDashboard = React.lazy(() =>
  import("./Dashboard/index.page")
);
export const ManageSubscription = React.lazy(() =>
  import("./ManageSubscription/index.page")
);
export const TransactionHistory = React.lazy(() =>
  import("./TransactionsHistory/index.page")
);
export const SupportPage = React.lazy(() =>
  import("./Support/index.page")
);
export const ManageNotifications = React.lazy(() =>
  import("./ManageNotification/index.page")
);
export const ManageBlogs = React.lazy(() =>
  import("./ManageBlogs/index.page")
);
export const CreateBlogs = React.lazy(() =>
  import("./ManageBlogs/CreateBlogs/index.page")
);
export const UpdateBlogs = React.lazy(() =>
  import("./ManageBlogs/UpdateBlogs/index.page")
);

// Exporting components related to user management and CMS management
export * from "./UserNutrition";
export * from "./UserManagement";
export * from "./ManageCms";
